<script lang="ts">
	// Type
	import type { CategoryMinData } from "@hitit/api";

	//Image
	import upArrow from "@hitit/hub/src/assets/Icons/upArrow.png";
	import downArrow from "@hitit/hub/src/assets/Icons/downArrow.png";

	export let value: string = "";
	export let category: CategoryMinData;
	export let categoryOpen: boolean;

	let itemOpen = false;

	function itemSelecte(itemName: string) {
		value = itemName;
		categoryOpen = false;
	}
</script>

<div class="category-box" t-id="ItemBox">
	<div class="inner-box" on:click={() => (itemOpen = !itemOpen)}>
		<div>{category.name}</div>
		<img src={itemOpen ? upArrow : downArrow} />
	</div>
	{#if itemOpen}
		<div class="item-box" />
		{#each category.storeItemMinDTOS as item}
			<div class="item" on:click={() => itemSelecte(item.name)}>
				{item.name}
			</div>
		{/each}
	{/if}
</div>

<style lang="scss">
	@import "../../../variables.scss";

	.category-box {
		display: flex;
		flex-direction: column;
		border-top: 1px solid #d8d9de;

		&:first-child {
			border-top: unset;
		}

		.inner-box {
			display: flex;
			justify-content: space-between;
			align-items: center;
			height: 40px;
		}
	}

	.item-box {
		display: flex;
		flex-direction: column;
		width: 100%;
		height: 100%;
	}

	.item {
		height: 34px;
	}

	img {
		width: 20px;
		height: 10px;
	}

	@include DesktopSize {
	}
</style>
